/**
 * The currently-selected Hospital (real backend entity —
 * `modules/platform/hospital`, `GET /hospitals`). A tenant may own
 * more than one Hospital; this store holds only the CURRENT
 * selection, not the list (the list is fetched by whichever feature
 * module needs it, via TanStack Query — this store has no HMIS
 * module implementation to fetch with yet, per this stage's own
 * scope).
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface HospitalSummary {
  id: string;
  legalName: string;
  displayName: string;
}

interface HospitalState {
  currentHospital: HospitalSummary | null;
  setHospital: (hospital: HospitalSummary | null) => void;
}

export const useHospitalStore = create<HospitalState>()(
  persist(
    (set) => ({
      currentHospital: null,
      setHospital: (hospital) => set({ currentHospital: hospital }),
    }),
    { name: 'nexao-hospital' },
  ),
);
